import { userInfoReducer } from './userInfoSlice';
export * from './selectors';
export * from './userInfoSlice';

export const userInfoReducers = {
   userInfoData: userInfoReducer,
};
